export default __webpack_public_path__ + "static/media/group.33cec2d8.svg";